import { BsAward } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import ManageLink from "../../components/shared/ManageLink";
import { MdCurrencyExchange } from "react-icons/md";

export default function Manage({
  children,
  title,
  subtitle,
  description,
  actions,
}: any) {
  const allMenus = [
    {
      id: 1,
      isActive: true,
      to: "/manage/users/active",
      name: "Active Users",
      icon: <FiUsers />,
    },

    {
      id: 2,
      isActive: true,
      to: "/manage/users/inactive",
      name: "Inactive Users",
      icon: <FiUsers />,
    },
    {
      id: 3,
      isActive: true,
      to: "/manage/users/unlinked",
      name: "Unlinked Users",
      icon: <FiUsers />,
    },

    {
      id: 4,
      isActive: true,
      to: "/manage/companies",
      name: "Companies",
      icon: <FiUsers />,
    },

    {
      id: 5,
      isActive: true,
      to: "/manage/claims",
      name: "Claims",
      icon: <BsAward />,
    },
    {
      id: 6,
      isActive: true,
      to: "/manage/currencies",
      name: "Currencies",
      icon: <MdCurrencyExchange />,
    },
  ];

  const menus = allMenus;

  return (
    <div className="grid grid-cols-12 gap-0 m-1 border rounded-lg ">
      <div className="bg-gray-50 col-span-1 rounded-l-lg  w-40">
        {menus.map((menu: any, index: number) => (
          <ManageLink to={`${menu.to}`} icon={menu.icon} key={index}>
            {menu.name}
          </ManageLink>
        ))}
      </div>
      <div className="bg-white col-span-11 h-full border-l rounded-r-lg">
        <div className="border-b p-4 flex justify-between items-center h-18">
          <div className="flex justify-center items-center">
            <div className="">
              <span className="text-lg font-bold">{title} : </span>
              <span>{subtitle}</span>
              <div className="">{description}</div>
            </div>
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
